<template>
  <div class="header">
    <div class="title-container">
      <h1>百川作业订正系统</h1>
      <span class="class-tag" v-if="displayedClassName !== '班级'" :style="{ backgroundColor: subjectColor }">
        {{ displayedClassName }}
      </span>
      <el-button
        type="text"
        icon="el-icon-finger"
        class="finger-guide-btn"
        @click="openFingerGuide"
      >
        新手指引
      </el-button>
      <el-button
        v-if="isPenaltyOwner"
        type="text"
        icon="el-icon-trophy"
        class="finger-guide-btn pf-entry-btn"
        @click="openPenaltyFree"
      >
        不罚
      </el-button>
    </div>
    <div class="poem">
      百川东到海，何时复西归？<br>
      少壮不努力，老大徒伤悲。
    </div>
    <div class="current-time">{{ currentTime }}</div>
    <FingerGuideDialog ref="fingerGuideDialog" />
    <PenaltyFreeDialog ref="penaltyFreeDialog" :classId="classId" />
  </div>
</template>

<script>
import Utils from '@/utils/Utils'
import FingerGuideDialog from '@/components/FingerGuideDialog.vue'
import PenaltyFreeDialog from '@/components/pc/PenaltyFreeDialog.vue'

export default {
  name: 'HeaderSection',
  components: {
    FingerGuideDialog,
    PenaltyFreeDialog
  },
  props: {
    classInfo: {
      type: Object,
      default: null
    },
    classId: {
      type: [Number, String],
      default: ''
    },
    currentTime: {
      type: String,
      default: ''
    },
    subjectIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    displayedClassName() {
      if (this.classInfo) {
        return Utils.formatClassName(this.classInfo.gradeLevel, this.classInfo.classNumber);
      }
      return '班级';
    },
    subjectColor() {
      const colors = [
        '#ff8c00',
        '#409EFF',
        '#ff1493'
      ];
      return colors[this.subjectIndex] || colors[0];
    },
    // 与移动端 MoreMobile 一致：仅功能所有者手机号可见"不罚"入口
    isPenaltyOwner() {
      try {
        const info = JSON.parse(localStorage.getItem('teacherInfo') || '{}')
        return info && info.phone === '13211069219'
      } catch (e) {
        return false
      }
    }
  },
  methods: {
    openFingerGuide() {
      this.$refs.fingerGuideDialog.open()
    },
    openPenaltyFree() {
      this.$refs.penaltyFreeDialog.open()
    }
  }
}
</script>

<style scoped>
.title-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  padding: 0 20px;
}

.title-container h1 {
  margin: 0;
  color: white !important;
  font-size: 28px;
  font-weight: bold;
  margin-right: 15px;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

.class-tag {
  background-color: #409EFF;
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 18px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.finger-guide-btn {
  color: white;
  font-size: 16px;
  padding: 8px 12px;
}

.finger-guide-btn:hover {
  opacity: 0.8;
}

/* 不罚入口：白色虚线边框突出按钮感，hover 边框变亮 */
.pf-entry-btn {
  border: 1px dashed rgba(255, 255, 255, 0.55);
  border-radius: 18px;
}

.pf-entry-btn:hover {
  border-color: rgba(255, 255, 255, 0.95);
}
</style>